(function($) {
  window.Edu = window.Edu || {};

  // Store cid in session storage (used by analytics trackers)
  if(window.Edu.queryString && window.Edu.queryString['cid']) {
    if(!window.sessionStorage.getItem('cid')) {
      window.sessionStorage.setItem('cid',window.Edu.queryString['cid']);
    }
    window.sessionStorage.setItem('current_cid', window.Edu.queryString['cid']);
  }

  // For SEO reasons, we don't want cids hard-coded in the URL.
  // On mousedown, convert `<a href="/" data-cid="1.1">` to `<a href="/?cid=1.1">`.
  // This hides the cid code from Google while real users who click on a link will still get the proper cid.
  // This method isn't fool-proof and some people will not get the cid inserted. That risk is worth the SEO reward.
  $(document).on('mousedown', 'a[data-cid]', function(e) {
    var a = e.target;
    var href = a.href;
    var cid = a.getAttribute('data-cid');

    // No href, skip
    if(!href || !href.length) {
      return;
    }
    // Already has a cid code, skip
    if(href.match(/[&?]cid=/)) {
      return;
    }
    // Invalid cid
    if(!cid.match(/^[0-9]+\.[0-9]+$/)) {
      return;
    }

    // Append cid to the existing link href
    if(href.match(/\?/)) {
      // Already has querystring
      href += '&cid='+cid;
    }
    else {
      // Needs a querystring
      href += '?cid='+cid;
    }

    a.href = href;
  });

  /** This will launch the kidframe in a separate browser window */
  window.Edu.launchWebGame = function(href, callback) {
    if (!href) return;

    var h = (screen.availHeight) ? screen.availHeight : screen.height,
        w = (screen.availWidth) ? screen.availWidth : screen.width;
    h = (h > 1250) ? 1250 : h;
    w = (w > 1920) ? 1920 : w;
    h = h - 14;
    w = w - 14;
    gameWindow = window.open(href, 'gameswindow', 'scrollbars=no,menubar=no,location=no,status=no,toolbar=no,outerHeight='+h+',height='+h+',outerWidth='+w+',width='+w+',fullscreen=yes,left=0,top=0,resizable=yes');
    gameWindow.focus();

    if (callback) callback();
  };

  /**** Special `debugLog` querystring that sends all javascript logs and errors to our server ****/
  if(window.location.href.match(/[?&]debugLog($|[&])/)) {
    var log = function(obj) {
      obj.url = window.location.href;
      $.post('/api/debugLog',obj);
    };

    // global js error listener
    var oldOnError = window.onerror;
    window.onerror = function (msg, url, lineNo, columnNo, error) {
      var string = msg.toLowerCase();
      var substring = "script error";
      if (string.indexOf(substring) > -1){
        // Ignore "script error" because we can't get any details out of it
      } else {
        log({
          type: 'onerror',
          message: msg,
          source: url,
          lineNo: lineNo,
          columnNo: columnNo,
          error: JSON.stringify(error)
        });
      }

      // This is a transparent intercept so continue calling the previous listener
      if(oldOnError && oldOnError.apply) {
        oldOnError.apply(window, [msg, url, lineNo, columnNo, error]);
      }
    };

    // Make sure console.log and console.error are defined
    if(!window.console || !window.console.log) {
      window.console = {
        log: function() {},
        error: function() {}
      };
    }

    // Intercept console.log calls
    var oldConsoleLog = window.console.log;
    window.console.log = function() {
      var args = Array.prototype.slice.call(arguments);
      log({
        type: 'console.log',
        args: JSON.stringify(args)
      });

      oldConsoleLog.apply(window.console, args);
    };


    // Intercept console.error calls
    var oldConsoleError = window.console.error;
    window.console.error = function() {
      var args = Array.prototype.slice.call(arguments);
      log({
        type: 'console.error',
        args: JSON.stringify(args)
      });

      oldConsoleError.apply(window.console, args);
    };
  }

  /**** Semi-transparent page overlay (used behind modals) ****/
  window.Edu.overlay = $("<div id='modal-overlay'></div>").on('click',function() {
    // Don't close a modal if it's still opening
    if(window.Edu.modal_open_timer) return;

    /** Exception: if this modal is the additional-info-request modal; refresh the page instead of closing it */
    var modalOpen = $('.modal.open');
    if (modalOpen[0] && modalOpen[0].id === 'additional-info-request') {
      window.location = window.location;
    }

    $('body').css('overflow', 'visible');
    modalOpen.removeClass('open');
    $('.search-filter.open').removeClass('open');
    $(this).fadeOut(500);
    $(document).trigger('modalClosed');

  });
  $(document).ready(function() {
    window.Edu.overlay.appendTo(document.body);
  });

  window.Edu.drawer = function(el, options) {
    if(!(this instanceof window.Edu.drawer)) {
      return new window.Edu.drawer(el, options);
    }

    this._$el = $(el);
    this._isOpen = false;
    this._$backdrop = null;
    this._mediaList = null;
    this._isActive = true;

    this._config = $.extend({
      /**
       * If enabled, display a backdrop.
       * @type {Boolean}
       */
      backdrop: true,
      /**
       * If enabled, close drawer with 'Esc' key.
       * @type {Boolean}
       */
      keyboard: true,
      /**
       * If enabled, close the drawer when clicking anywhere outside the drawer.
       * @type {Boolean}
       */
      dismiss: true,
      /**
       * Duration of animations used when opening/closing the sidebar. Only change if animations have been
       * overridden.
       * @type {Number}
       */
      animate: 225,
      /**
       * Optional media query to toggle responsive behavior when matching.
       * @type {?string}
       */
      media: null
    }, this._$el.data, options);

    // Bind internal dismiss handler
    this._$el.on('click.edu.drawer', '[data-dismiss="drawer"]', this.close.bind(this));

    // Bind global open drawer listeners
    $('[data-open="drawer"]').on('click.edu.drawer', this._onGlobalOpen.bind(this));

    // Setup media query listener for responsive behavior
    if(this._config.media) {
      this._mediaList = window.matchMedia(this._config.media);
      this._handleMediaChange(this._mediaList);
      this._mediaList.addListener(this._handleMediaChange.bind(this));
    }
  };
  window.Edu.drawer.prototype = {
    CLASS_BACKDROP: 'drawer__backdrop',
    CLASS_ACTIVE: 'active',
    CLASS_IN: 'in',
    CLASS_OUT: 'out',
    CLASS_OPEN: 'open',
    _handleMediaChange: function(mediaList) {
      if(mediaList.matches) {
        this._$el.addClass(this.CLASS_ACTIVE);
        this._isActive = true;
      } else {
        this.close();
        this._$el.removeClass([this.CLASS_ACTIVE, this.CLASS_OUT].join(' '));
        this._isActive = false;
      }
    },
    _onGlobalOpen: function(event) {
      var selector = $(event.target).data('target');
      if(this._$el.is(selector)) {
        this.open();
      }
    },
    _onKeyDown: function(event) {
      switch(event.which) {
        case 27: // escape
          if(this._config.keyboard) {
            this.close();
          }
          break;
      }
    },
    open: function() {
      if(this._isOpen || !this._isActive)
        return;

      this._isOpen = true;
      this._$backdrop = $('<div class="'+ this.CLASS_BACKDROP +'" />').appendTo('body');
      this._$backdrop
        .addClass(this.CLASS_OPEN)
        .removeClass(this.CLASS_OUT);
      this._$el
        .addClass([this.CLASS_OPEN, this.CLASS_IN].join(' '))
        .removeClass(this.CLASS_OUT);
      this._$el.get(0).focus();
      // Bind keyboard events
      $(document).on('keydown.edu.drawer', this._onKeyDown.bind(this));
      // Bind global dismiss handler if option enabled
      if(this._config.dismiss) {
        this._$backdrop.on('click.edu.drawer', this.close.bind(this));
      }
    },
    close: function() {
      if(!this._isOpen || !this._isActive)
        return;

      this._isOpen = false;
      this._$el.removeClass([this.CLASS_OPEN, this.CLASS_IN].join(' ')).addClass(this.CLASS_OUT);
      this._$backdrop.removeClass(this.CLASS_OPEN).addClass(this.CLASS_OUT);
      $(document).off('keydown.edu.drawer');
      setTimeout(function() {
        this._$backdrop.remove();
      }.bind(this), this._config.animate);
    },
    toggle: function() {
      return this._isOpen ? this.close() : this.open();
    }
  };

  // Auto-invalidate caches based on ajax calls
  $(document).ajaxSend(function(event,xhr,settings) {
    // Catch all requests that modify data
    if(settings && settings.type && ['POST','PUT','PATCH','DELETE'].indexOf(settings.type.toUpperCase()) >= 0) {
      // Changing a student or group
      if(settings.url.match(/\/api\/child/)) {
        window.Edu.api.invalidateStudentsCache();
        window.Edu.api.invalidateStudentGroupsCache();
      }
      else if(settings.url.match(/\/games\/request\/user\//)) {
        window.Edu.api.invalidateStudentsCache();
        window.Edu.api.invalidateStudentGroupsCache();
      }
      // Changing an assignment
      else if(settings.url.match(/\/api\/assignment/)) {
        window.Edu.api.invalidateAssignmentsCache();
      }
    }
  });
  // Periodically flush all expired cache items from localStorage
  if(Math.random() < 0.1) {
    (function () {
      var key, value;
      var prefixRegExp = new RegExp('^' + window.Edu.cache.prefix);
      var now = (new Date()).getTime();
      // Need to count down since removeItem changes the indexes
      for (var i = localStorage.length - 1; i >= 0; --i) {
        key = localStorage.key(i);
        if (key && key.match(prefixRegExp)) {
          value = localStorage.getItem(key);
          if (value) {
            value = JSON.parse(value);
            if (!value || !value.expires || !value.data || value.expires < now) {
              localStorage.removeItem(key);
            }
          }
        }
      }
    })();
  }

  /**** Ads Gutter ****/
  $(document).ready(function() {
    var adsGutter = $('.ads-gutter');
    if(adsGutter.find('.ad-container-gutter:visible').length) {
      $(document.body).addClass('with-ad-gutter');
      if (adsGutter.find('.gutter-bottom').length > 0) {
        adsGutter.height(2200);
      }
    }
    else {
      $(document.body).removeClass('with-ad-gutter');
    }
  });
  // `window.Edu.setupAdGutter` should be called immediately after adding
  // the ad gutter div to the page to prevent the page from jumping
  // This is just a fallback in case that step is forgotten.
  $(document).ready(window.Edu.setupAdGutter);

  /**** Detect touch support ****/
  //window.isTouch = (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch);
  window.isTouch = false;
  $(document).ready(function() {
    $(document.body).one('touchstart',function(e) {
      window.isTouch = true;
      $(document.body).addClass('touch');
    });
  });

  /**** Star Ratings ****/
  $.fn.starRating = function(options) {
    options = options || {};

    var update = function(container,rating,count) {
      rating = rating*1;
      count = count*1;

      // Update rating text
      if(count) {
        $('.rating-info', container).text(rating.toFixed(1)+' based on '+count+' rating'+(count!=1?'s':''));
      }
      else {
        $('.rating-info', container).html('<span>no ratings yet</span>');
      }

      // Update stars
      $('.star',container).each(function(i,el) {
        if(rating <= i) {
          $('.full',el).css('width',0);
        }
        else if(rating >= i+1) {
          $('.full',el).css('width','100%');
        }
        else {
          $('.full',el).css('width',(rating-i).toFixed(4)*100+'%');
        }
      });
    };
    var signup_form = $("#signup-form");
    return this.each(function() {
      var container = $(this);
      var uid = container.attr('data-uniqueid');
      var type = container.attr('data-ratingtype');
      var content_type = container.attr('data-contenttype');
      container.on('click','.star',function() {
        var rating = $(this).attr('data-rating');

        if(container.attr('data-showlogin') !== undefined) { //user not logged in and require login set
          if (!signup_form.length) return;
          signup_form.modal('show');
        } else {
          $.post(window.location.href, {
            uniqueID: uid,
            type: type,
            contentType: content_type,
            __json: "AddRating",
            rating: rating,
            newStarRating: 1
          }, function (response) {
            //console.log(response);
            if (response && response.rating) {
                var ratingValue = response.rating.avg;
                if(container.attr('data-hideratingsaverage') !== undefined) {
                    ratingValue = rating;
                }
                update(container, ratingValue, response.rating.count);
            }
          });
        }
      });
    });
  };
  $(document).ready(function() {
    $('.star-rating.interactive').starRating();
    $('.star-rating-page.interactive').starRating();
  });

  /**** Refresh Ads ****/
  window.Edu.refreshAds = function() {
    // Deprecated
  };

  /**** Paywall Functions ****/
  window.Edu.getLocalStorageRemainingCredits = function () {
    try {
      if (window.localStorage) {
        var creditsRemaining = window.localStorage.getItem('creditsRemaining');
        //is this a number
        if (!isNaN(parseFloat(creditsRemaining)) && isFinite(creditsRemaining)
          && creditsRemaining >= 0) {
          return creditsRemaining;
        }
        else {
          return 1;
        }
      }
    }
    catch(e) {}
    return 0;
  };
  window.Edu.decrementLocalStoragePaywallCount = function () {
    if (window.localStorage) {
      var creditsRemaining = window.Edu.getLocalStorageRemainingCredits();

      if (creditsRemaining > 0) {
        try {
          window.localStorage.setItem('creditsRemaining', creditsRemaining - 1);
        }
        catch (e) {}
      }
    }
  };

  /**** Fixed Container While Scrolling ****/
  $(document).ready(function() {
    var raf = window.requestAnimationFrame || function(callback) {callback();};

    function Fixtop (el) {
      this.el = el;
      this.startingPosition = 0;
      this.parent = null;
      this.offsetParent = el.parent();
      this.isFixed = false;

      this.init = function () {
        if(this.el.attr('data-parent')) {
          this.parent = $(this.el.attr('data-parent'));
          this.startingPosition = this.el.offset().top;
        }

        this.scroll();
      };

      this.fixToTop = function () {
        if(this.isFixed) return;
        this.isFixed = true;
        this.el.css({
          position: 'fixed',
          top: 0,
          bottom: ''
        });
      };

      this.unfixToTop = function () {
        if(!this.isFixed) return;
        this.isFixed = false;
        this.el.css({
          position: '',
          left: '',
          top: '',
          bottom: ''
        });
      };

      var doc = $(document);
      var adHeight, scrollHeight, top;

      this.scroll = function () {
        adHeight = this.el.height();
        scrollHeight = doc.scrollTop();

        // We're below the scroll window
        if ((this.parent.offset().top + this.parent.height()) <= scrollHeight + adHeight) {
          this.unfixToTop();
          top = this.parent.offset().top + this.parent.height() - adHeight;

          // The fixed element's parent is not static, remove the extra top value
          if(this.offsetParent.css('position')!=='static') {
            top -= this.offsetParent.offset().top;
          }

          // Set the new absolute top value
          this.el.css({'top': top, 'position': 'absolute'});
        }
        else {
          // We're currently within the scroll window
          if (scrollHeight > this.startingPosition) {
            this.fixToTop();
          }
          // We're above the scroll window
          else {
            this.unfixToTop();
          }
        }
      };

      this.init();
    }

    $(window).on('load',function() {
      $('.fixtop').each(function() {
        var fixtop = new Fixtop($(this));

        $(window).on('scroll',function() {
          raf(function() {
            fixtop.scroll();
          });
        });
      });
    });
  });

  /**** Obscure phone numbers ****/
  $(document).ready(function() {
    $('.fixtelephone').each(function (i,el) {
      el = $(el);
      var phoneMap = {
        'ZERO': '0',
        'ONE': '1',
        'TWO': '2',
        'THREE': '3',
        'FOUR': '4',
        'FIVE': '5',
        'SIX': '6',
        'SEVEN': '7',
        'EIGHT': '8',
        'NINE': '9',
        'DASH': '-'
      };

      var splitOriginalText = el.text().split(" ");
      var phoneNumber = "";
      $.each(splitOriginalText, function(i, num) {
        phoneNumber = phoneNumber.concat(phoneMap[num]);
      });

      el.replaceWith($("<a>").attr('href','tel:'+phoneNumber).text(phoneNumber));
    });
  });

  /**** Obscure email addresses ****/
  $(document).ready(function() {
    $('.fixemail').each(function (i,el) {
      el = $(el);

      //if the href is already a mailto link, just fix the email there
      if (el.tag == 'a' && el.attr('href').substr(0, 7) == 'mailto:') {
        el.attr('href', el.get('href').replace(' AT ', '@').replace(' DOT ', '.'));
        el.text(el.text().replace(' AT ', '@').replace(' DOT ', '.'));

        //remove the fixemail class
        el.removeClass('fixemail');
      }
      else {
        var email = el.text().replace(' AT ', '@').replace(' DOT ', '.');

        el.replaceWith($("<a>").attr('href','mailto:'+email).text(email));
      }
    });
  });

  /**** Form Toggle Buttons ****/
  $(document).on('change','.toggle-switch input', function() {
    if(this.checked) {
      $(this).parent().addClass('checked');
    }
    else {
      $(this).parent().removeClass('checked');
    }
  });
  $(document).on('change','label.button input', function() {
    if(this.checked) {
      $(this).parent().addClass('checked');
      // For radio buttons, trigger 'change' event for all deselected options
      if(this.type === 'radio' && this.name) {
        $('input[type="radio"][name="'+this.name+'"]').each(function() {
          if(!this.checked) {
            $(this).trigger('change');
          }
        });
      }
    }
    else {
      $(this).parent().removeClass('checked');
    }
  });
  // Trigger initial change event
  $(document).ready(function() {
    $('.toggle-switch input:checked, label.button input:checked').trigger('change');
    $('.stepper input[type="number"]').trigger('change');
  });

  /**** Form Numeric Stepper ****/
  $(document).on('change','.stepper input[type="number"]',function(e) {
    var min = $(this).attr('min')*1;
    var max = $(this).attr('max')*1;
    var step = $(this).attr('step')*1||1;
    var value = this.value*1;

    if(value > max) {
      value = max;
      this.value = max;
    }
    else if(value < min) {
      value = min;
      this.value = min;
    }

    this.value = value - value % step;
    value = this.value;


    var stepper = $(this).closest('.stepper');
    var decrement = stepper.find('.decrement');
    var increment = stepper.find('.increment');

    // Disable decrement button when we're already at the minimum value
    if(min !== null && min !== undefined && value <= min) {
      decrement.addClass('disabled');
    }
    else {
      decrement.removeClass('disabled');
    }

    // Disable increment button when we're already at the maximum value
    if(max !== null && max !== undefined && value >= max) {
      increment.addClass('disabled');
    }
    else {
      increment.removeClass('disabled');
    }
  });
  $(document).on('click','.stepper .decrement',function(e) {
    e.preventDefault();
    if($(this).hasClass('disabled')) return;
    var input = $(this).closest('.stepper').find('input');
    var step = $(input).attr('step')*1;
    step = step?step:1;
    input[0].value = input[0].value*1 - step;
    input.trigger('change');
  });
  $(document).on('click','.stepper .increment',function(e) {
    e.preventDefault();
    if($(this).hasClass('disabled')) return;
    var input = $(this).closest('.stepper').find('input');
    var step = $(input).attr('step')*1;
    step = step?step:1;
    input[0].value = input[0].value*1 + step;
    input.trigger('change');
  });

  /**** Floating Form Labels ****/
  var setFloatingLabelClass = function() {
    // Focused or not empty
    var focused = (this === document.activeElement);
    var notEmpty = focused || this.value.length;
    var label = $(this).closest('label');

    if(focused) {
      if(!label.hasClass('focus')) {
        label.addClass('focus');
      }
    }
    else {
      label.removeClass('focus');
    }

    if(notEmpty) {
      if(!label.hasClass('not-empty')) {
        label.addClass('not-empty');
      }
    }
    else {
      label.removeClass('not-empty');
    }
  };
  $(document).on('focus','label.floating :input',setFloatingLabelClass);
  $(document).on('blur','label.floating :input',setFloatingLabelClass);
  $(document).on('change','label.floating :input',setFloatingLabelClass);
  $(document).on('ready',function() {
    $('label.floating :input').each(setFloatingLabelClass);
  });

  /**** Tabs ****/
  var tabClickEvent = function(e) {
    var tabs = $(this).closest('.tabs');

    var containerSelector = tabs.attr('data-target');
    var screenSelector = $(this).attr('data-target');
    if(containerSelector && screenSelector) {
      e.preventDefault();

      // Update 'active' class on the switcher
      $('a',tabs).removeClass('active');
      $(this).addClass('active');

      // Update 'active' class on the content
      var container = $(containerSelector);
      $('> div',container).removeClass('active')
        .filter(screenSelector).addClass('active');
    }
  };
  $(document).on('click','.tabs.overlapped-buttons a',tabClickEvent);
  $(document).on('click','.tabs a',tabClickEvent);

  /**** Inline Dropdowns ****/
  $(document).on('click','.inline-dropdown .toggle',function(e) {
    e.preventDefault();
    var dropdown = $(this).closest('.inline-dropdown');
    if(dropdown.hasClass('open')) {
      dropdown.removeClass('open');
    }
    else {
      // Hide all other open dropdowns
      $('.inline-dropdown.open').removeClass('open');
      dropdown.addClass('open');
    }
  });
  $(document).on('click',function(e) {
    // Clicked on the dropdown toggle, don't do anything
    var t = $(e.target);
    if(t.closest('.inline-dropdown').length && t.closest('.toggle').length) {
      return;
    }

    // Clicked somewhere else on the page, close all open dropdowns
    $('.inline-dropdown.open').removeClass('open');
  });


  var uniqueId = (function() {
    var id = 0;
    return function(prefix) {
      if(prefix == null) prefix = 'id';
      id++;
      return prefix + ":" + id;
    };
  })();

  /******* Custom Dropdown ************/
  window.Edu.dropdown = function(el) {
    if(!(this instanceof window.Edu.dropdown)) {
      return new window.Edu.dropdown(el);
    }

    this._isOpen = false;
    this._$combobox = $(el);
    this._$listbox = this._$combobox.find('ul:first');
    this._$options = this._$listbox.find('li:not(.disabled)');
    this._$label = this._$combobox.find('.label');
    this._$value = this._$combobox.find('.display-text');
    this._$input = this._$combobox.find('.select-value');
    this._$selected = this._$options.filter('.selected:first');
    this._$focused = null;
    this._init();
  };

  window.Edu.dropdown.prototype = {
    _init: function() {
      // Assign IDs to elements which need them for accessibility references (combobox, listbox, label, pseudovalue)
      this._assignId(this._$combobox);
      this._assignId(this._$listbox);
      this._assignId(this._$label);
      this._assignId(this._$value);

      // Set accessibility attributes
      this._$combobox
        .attr('role', 'combobox')
        .attr('tabindex', 0)
        .attr('aria-autocomplete', 'none')
        .attr('aria-expanded', 'false')
        .attr('aria-owns', this._$listbox.prop('id'))
        .attr('aria-labelledby', [this._$label.prop('id'), this._$value.prop('id')].join(' ').trim());
      this._$listbox
        .attr('role', 'listbox');
      this._$options
        .attr('role', 'option')
        .attr('aria-selected', 'false')
        .attr('tabindex', -1);

      // Initialize selected option (if there is one)
      if(this.value.length > 0) {
        this._select(this._$options.filter('[data-value="'+ this._$input.val() +'"]'));
      }

      // Bind event listeners
      this._$combobox.on('click', this.open.bind(this));
      this._$combobox.on('focusout', this._onFocusOut.bind(this));
      this._$combobox.on('keydown', this._onKeyDown.bind(this));
      this._$options.on('click', function(event) {
        event.stopPropagation();
        this._select($(event.target));
        this.close();
      }.bind(this));

    },

    _onGlobalClick: function(event) {
      if(!$(event.target).closest(this._$combobox).length && this._$combobox.is(':visible')) {
        this.close();
      }
    },

    _onKeyDown: function(event) {
      switch(event.which) {
        case 38: // up
          event.preventDefault();
          !this._isOpen ? this.open() : this.prev();
          break;

        case 40: // down
          event.preventDefault();
          !this._isOpen ? this.open() : this.next();
          break;

        case 36: // home
          if(this._isOpen) {
            event.preventDefault();
            this._focus(this._$options.first());
          }
          break;

        case 35: // end
          if(this._isOpen) {
            event.preventDefault();
            this._focus(this._$options.last());
          }
          break;

        case 32: // space
          event.preventDefault();
          this._activate();
          break;

        case 27: // escape
          this.close();
          break;
      }
    },

    _onFocusOut: function(event) {
      if(!$(event.relatedTarget).closest(this._$combobox).length && this._isOpen) {
        this.close();
      }
    },

    _activate: function() {
      if(this._isOpen) {
        this._select(this._$focused);
        this.close();
      } else {
        this.open();
      }
    },

    _assignId: function($el) {
      return $el.prop('id', $el.prop('id') || uniqueId('edu-dropdown'));
    },

    _select: function($el) {
      this._$selected.attr('aria-selected', 'false');
      this._$selected.removeClass('selected');
      this._$selected = $el;
      this._$selected.attr('aria-selected', 'true');
      this._$selected.addClass('selected');
      this._$value.text($el.text());
      this._$input.val(this._$selected.data('value'));
      this._$combobox.addClass('not-empty');
      this._$combobox.get(0).value = this.value();
      this._$combobox.get(0).dispatchEvent(new Event('change'));
    },

    _focus: function($el) {
      var $old = this._$focused;
      this._$focused = $el || (this._$selected.length ? this._$selected : this._$options.first());
      this._$focused.attr('tabindex', 0);
      this._$focused.eq(0).focus();

      if($old != null)
        $old.attr('tabindex', -1);
    },

    next: function() {
      var $next = this._$focused.nextAll('li[role="option"]').first();
      if($next.length !== 1) {
        $next = this._$options.first();
      }
      this._focus($next);
    },

    prev: function() {
      var $prev = this._$focused.prevAll('li[role="option"]').first();
      if($prev.length !== 1) {
        $prev = this._$options.last();
      }
      this._focus($prev);
    },

    open: function() {
      this._isOpen = true;
      this._$listbox.addClass('open');
      this._$combobox.attr('aria-expanded', 'true');
      this._focus();
      $(document).on('click.dropdown', this._onGlobalClick.bind(this));
    },

    close: function() {
      this._isOpen = false;
      this._$listbox.removeClass('open');
      this._$options.attr('tabindex', -1);
      this._$combobox.attr('aria-expanded', 'false');
      this._$combobox.get(0).focus();
      $(document).off('click.dropdown');
    },

    value: function() {
      return this._$input.val();
    }
  };

  $(document).ready(function() {
    $('.custom-dropdown').each(function(i, el) {
      // skip if it also has class .custom-dropdown-react
      if(!this.classList.contains('custom-dropdown-react')){
        window.Edu.dropdown(this);
      }

    });
  });

  /**** Smooth Scroll ****/
  window.Edu.scrollTo = function(el, duration, dir) {
    if(!el.length) return;

    duration = duration || 500;
    dir = dir || 'both';

    var newScrollTop = el.offset().top;

    if(dir === 'up' || dir === 'down') {
      var currentScrollTop = document.body.scrollTop + $('html')[0].scrollTop;
      // Only scrolling up and we're already above the target
      if(dir === 'up' && currentScrollTop <= newScrollTop) {
        return;
      }
      // Only scrolling down and we're already past the target
      else if(dir === 'down' && currentScrollTop >= newScrollTop) {
        return;
      }
    }

    $('html,body').animate({
      scrollTop: newScrollTop
    },duration);
  };
  $(document).on('click','a.smooth-scroll',function(e) {
    // Make sure it's a valid link to an element on the page
    var id = $(this).attr('href');
    if(!id || !id.match(/^#/)) return;
    var target = $(id);
    if(!target.length) return;
    e.preventDefault();
    window.Edu.scrollTo(target);
  });

  /**** Notifications and Member Area ****/
  $(document).ready(function () {
    function MemberSection() {
      // New nav
      if($('header.reorg').length) {
          this.memberNotificationsSelector = 'header.reorg';
          this.memberNotificationsListSelector = '.notifications-list';
          this.enableMemberDropdownToggle = false;
      }
      // Old nav
      else {
          this.memberNotificationsSelector = '.notifications-container';
          this.memberNotificationsListSelector = '.notifications';
          this.enableMemberDropdownToggle = true;
      }

      this.singleMemberNotification = '.notification';
      this.memberDropdownMenuSelector = '.member-dropdown-button';
      this.memberDropdownMenuListSelector = '.dropdown-content';

      this.memberNotificationsContainer = $(this.memberNotificationsSelector);
      this.memberNotificationsTotalContainer = this.memberNotificationsContainer.find('.num-notifications');
      this.memberNotificationsTotal = 0;
      this.memberNotifications = this.memberNotificationsContainer.find(this.memberNotificationsListSelector);
      this.memberNotificationsOpen = false;
      this.memberDropdownMenuContainer = $('.member-dropdown');
      this.memberDropdownMenu = this.memberDropdownMenuContainer.find(this.memberDropdownMenuListSelector);
      this.noNotificationsMessage = 'You don\'t have new notifications.';
      this.memberDropdownOpen = false;
      this.deletedNotificationsVariableName = 'deletedNotifications';
      this.bannersContainer = $('.banner-notifications-container');

      this.loadMemberRegularNotifications = function () {
        var self = this;
        var url = '/api/notifications';
        if(window.location.search.match(/([&?]|^)nocache([&]|$)/)) {
          url += '?nocache';
        }

        $.ajax({
          dataType: 'json',
          method: 'GET',
          url: url,
          data: {
            path: location.pathname[0] == '/' ? location.pathname.substr(1, location.pathname.length-1) : location.pathname
          }
        }).done(function(result) {
          self.memberNotifications.find('.notification').remove();
          if (result.regularNotifications.length > 0) {
            $.each(result.regularNotifications, function (key, notification) {
              var notificationClassName = 'notification-unread font-primary-bold';
              if (notification.status == 1) {
                notificationClassName = 'notification-read';
              }

              // Checking that the notification is removeable
              if (!('removable' in notification) || ('removable' in notification && notification.removable)) {
                  notification.text += '<i class="delete-'+notification.id+' notification-delete icon-cancel-circled2"></i>';
                  $('.delete-all-notifications').show();
              }

              $("<div></div>").html(notification.text)
                .addClass('notificationId-'+notification.id+' notification '+notificationClassName)
                .appendTo(self.memberNotifications);
            });
            self.memberNotificationsTotal = result.regularNotificationsTotal;
            self.updateNotificationsTotalDisplay();
          }
          else {
            $('.delete-all-notifications').hide();
            self.addNoNotificationsMessage(result.total);
          }

          self.bannersContainer.find('.banner-notification').remove();
          if (result.bannerNotifications.length > 0) {
            $.each(result.bannerNotifications, function (key, notification) {
              if (window.Edu.memberId == 0 && self.deletedNotificationInLocalStorage(notification.id)) {
                return true;
              }
              var deleteButtonHtml = '';
              if (notification.removable) {
                deleteButtonHtml = '<i class="delete-'+notification.id+' notification-delete icon-cancel-light"></i>';
              }
              var container = $("<div></div>").html(notification.text)
                .addClass('banner-notification')
                .appendTo(self.bannersContainer);

              container.find('div:first').css('position','relative').append(deleteButtonHtml);
            });

            self.bannersContainer.lazyload();
          }
        });
      };

      this.toggleDisplayMemberDropdown = function () {
        this.hideMemberNotifications();
        if (this.memberDropdownOpen) {
          this.memberDropdownOpen = false;
          this.hideMemberDropdown();
        }
        else {
          this.memberDropdownOpen = true;
          this.showMemberDropdown();
        }
      };
      this.toggleDisplayMemberNotifications = function () {
        this.hideMemberDropdown();
        if (this.memberNotificationsOpen) {
          this.hideMemberNotifications();
        }
        else {
          this.showMemberNotifications();
        }
      };
      this.showMemberDropdown = function () {
        this.memberDropdownMenu.css('display', 'inline-block');
      };
      this.updateNotificationsTotalDisplay = function () {
        if (this.memberNotificationsTotal > 0) {
          this.memberNotificationsTotalContainer.html(this.memberNotificationsTotal).addClass('red-bg')
            .css('display', 'inline-block');
        }
        else {
          this.memberNotificationsTotalContainer.css('display', 'none');
        }
      };

      this.hideMemberDropdown = function () {
        this.memberDropdownOpen = false;
        this.memberDropdownMenu.css('display', 'none');
      };
      this.hideMemberNotifications = function () {
        this.memberNotificationsOpen = false;
        this.memberNotifications.css('display', 'none');
      };
      this.showMemberNotifications = function () {
        this.memberNotificationsOpen = true;
        this.memberNotifications.css('display', 'inline-block');
      };

      this.hideAll = function () {
        this.hideMemberDropdown();
        this.hideMemberNotifications();
      };

      this.deleteNotification = function (notification, notificationId) {
        if (notification.hasClass('notification')) {
          this.memberNotificationsTotal--;
          this.updateNotificationsTotalDisplay();
        }
        $('.notificationId-'+notificationId).remove();
      };

      this.deleteAllNotifications = function () {
        this.memberNotificationsTotal = 0;
        this.updateNotificationsTotalDisplay();
        $('.notification').has('.notification-delete').remove();
      };

      this.addNoNotificationsMessage = function () {
        if (!$(this.singleMemberNotification).length) {
          $("<div></div>").appendTo(this.memberNotifications).addClass('notification').text(this.noNotificationsMessage);
        }
      };

      this.deletedNotificationInLocalStorage = function (notificationId) {
        var deletedNotificationInLocalStorage = false;
        try {
          if (window.localStorage) {
            var deletedNotifications = this.getDeletedNotificationsFromLocalStorage();
            $.each(deletedNotifications, function (key, deletedNotificationId) {
              if (notificationId == deletedNotificationId) {
                deletedNotificationInLocalStorage = true;
              }
            });
          }
        }
        catch(e) {}
        return deletedNotificationInLocalStorage;
      };

      this.updateLocalStorageDeletedNotifications = function (notificationId) {
        try {
          if (window.localStorage) {
            var deletedNotifications = this.getDeletedNotificationsFromLocalStorage();
            deletedNotifications.push(notificationId);
            window.localStorage.setItem(this.deletedNotificationsVariableName, JSON.stringify(deletedNotifications));
          }
        }
        catch(e) {}
      };

      this.updateLocalStorageAllDeletedNotifications = function (notificationIds) {
        try {
          if (window.localStorage) {
            var deletedNotifications = this.getDeletedNotificationsFromLocalStorage();
            for (var i = 0; i < notificationIds.length; i++) {
              deletedNotifications.push(notificationIds[i]);
            }

            window.localStorage.setItem(this.deletedNotificationsVariableName, JSON.stringify(deletedNotifications));
          }
        }
        catch(e) {}
      };

      this.getDeletedNotificationsFromLocalStorage = function () {
        try {
          if (window.localStorage) {
            var deletedNotifications = window.localStorage.getItem(this.deletedNotificationsVariableName);
            if (deletedNotifications) {
              deletedNotifications = JSON.parse(deletedNotifications);
            }
            else {
              deletedNotifications = [];
            }

            return deletedNotifications;
          }
        }
        catch(e) {}

        return [];
      };

      /** Makes ajax request that marking the notification as read and redirects if needed */
      this.readNotification = function(el) {
        // Checking that the url exist
        var url = el.getAttribute('data-href');
        if (url) {
          $.ajax({
              dataType: 'json',
              method: 'GET',
              url: url,
              async: false,
              success: function (result) {
                if (result && result.status && result.redirectUrl) {
                  // Checking if there needs to be a new tab opened
                  if (el.getAttribute('target') && el.getAttribute('target') == '_blank') {
                    window.open(result.redirectUrl, '_blank');
                  } else {
                    window.location = result.redirectUrl;
                  }
                }
              }
          });
        }
      };
    }

    var memberSection = new MemberSection();
    memberSection.loadMemberRegularNotifications();

    /**
     * Listener on clicks for the links in the individual notifications and the notification banner
     */
    $(document).on('click', '.notification a, .banner-notifications-container a', function (e) {
        e.preventDefault();
        memberSection.readNotification(this);
    });

    $(document).on('click', '.delete-all-notifications', function(e) {
      e.preventDefault();

      var notifications = $('.notification').has('.notification-delete');
      var notificationIds = [];

      notifications.each(function() {
        notificationIds.push($(this).attr('class').split(' ')[0].split('notificationId-')[1]);
      });

      if (window.Edu.memberId == 0) {
        memberSection.updateLocalStorageAllDeletedNotifications(notificationIds);
      }
      else {
        $.ajax({
          dataType: 'json',
          method: 'POST',
          url: '/api/notification/delete-all'
        });
      }

      var scene = $(this);
      notifications.fadeOut(500, function(){
        memberSection.deleteAllNotifications();
        memberSection.addNoNotificationsMessage();
        scene.fadeOut(250);
      });
    });

    $(document).on('click', '.notification-delete', function (e) {
      e.preventDefault();

      var notificationId = $(this).attr('class').split(' ')[0];
      notificationId = notificationId.split('delete-')[1];

      if (window.Edu.memberId == 0) {
        memberSection.updateLocalStorageDeletedNotifications(notificationId);
      }
      else {
        $.ajax({
          dataType: 'json',
          method: 'POST',
          url: '/api/notification/delete/' + notificationId
        });
      }

      $(this).parent().fadeOut(500, function(){
        memberSection.deleteNotification($(this), notificationId);
        memberSection.addNoNotificationsMessage();
      });
    });

    if(memberSection.enableMemberDropdownToggle) {
        $(document).on('click', function (e) {
            if ($(e.target).parents(memberSection.memberDropdownMenuSelector).length) {
                if (!$(e.target).parents(memberSection.memberDropdownMenuListSelector).length) {
                    memberSection.toggleDisplayMemberDropdown();
                }
            }
            else if ($(e.target).parents(memberSection.memberNotificationsSelector).length) {
                if (!$(e.target).parents(memberSection.memberNotificationsListSelector).length) {
                    memberSection.toggleDisplayMemberNotifications();
                }
            }
            else {
                memberSection.hideAll();
            }
        });
    }

    //  AB TEST: ROLY/KIDMODE BUTTON IN TOP NAV

    $(document).on('click', '.kidmode-regwall', function (e) {
      e.preventDefault();
      var signup_form = $("#signup-form");

      if (signup_form) {
        var parentEl =  signup_form.find('div.create-account .signup-form');
        var originalTitle = parentEl.find('h3').html();
        var originalDescription = parentEl.find('p.description').html();
        $(document).on('modalClosed', function () {
          signup_form.modal('setRegisterTitle', originalTitle);
          signup_form.modal('setRegisterDescription', originalDescription);
        });

        var kidmodeTitle = "Join Education.com for Free Access to Games";
        var kidmodeDescription = "You'll get access to free games and other resources by becoming a member of Education.com.";
        signup_form.modal('setRegisterTitle', kidmodeTitle);
        signup_form.modal('setRegisterDescription', kidmodeDescription);
        signup_form.modal('showCreateAccount');
        signup_form.modal('show');
      }
    });

  });

  /**** Collections ****/
  window.Edu.Collectible = (function(){
    var collectibleContent = {};
    var fetchedCollections = false;
    var collectionId = 'pending';
    var collections = [];
    var pendingItem = null;
    var timeout = null;

    var populate = function() {
      collectibleContent = {};
      $('.content-result:not(.in-collection-tray):not([data-collectible="0"])').each(function() {
        populateItem(this);
      });
      $('.collectible-content-item.inline:not([data-collectible="0"])').each(function() {
        populateItem(this);
      });
    }
    var populateItem = function(el) {
      var $a, type, id, title, thumbnail;
      $a = $(el).children('a').first();
      var elementType = $(el).hasClass('inline') ? 'inline' : 'content-card';
      if(elementType==='content-card') {
        type = $a.attr('data-type');
        id = $a.attr('data-id');
        title = $(el).find('.title').first().find('span').first().html() || $(el).find('.title').first().html();
        thumbnail = $(el).find('.image').first().find('img').first().attr('src');
        if(!thumbnail){
          thumbnail = $(el).find('.image').first().find('img').first().attr('data-src');
        }
        if(!thumbnail){
          thumbnail = $(el).find('.image').first().find('img').first().attr('data-lazyload-src');
        }
      } else {
        elementType = 'inline';
        type = $(el).attr('data-type');
        id = $(el).attr('data-id');
        title = $(el).attr('data-title');
        thumbnail = $(el).attr('data-thumbnail');
      }

      title = title == null ? "" : title.replace(/<[^>]*>?/gm, '').replace(/"/g, '&quot;');
      var collectedIn = [];

      if (type && id) {
        for(var cid in collections){
          var collection = collections[cid];
          if(collection.content) {
            for (var key in collection.content) {
              var item = collection.content[key];
              if(item.type===type && item.id===id){
                collectedIn.push(cid);
              }
            }
          }
        }
        collectibleContent[type+'|'+id] = {id: id, type: type, el: el, collectedIn: collectedIn};

        $('#collections').removeClass('hidden');
        fetchCollections();

        if(elementType==='content-card') {
          $(el).append(
            '<div class="collectible-content-item">\
              <div class="btn btn-tertiary btn-round btn-collect' + (collectedIn.length?' selected':'') + '" data-id="' + id + '" data-type="' + type + '" data-title="' + title + '" data-thumbnail="' + thumbnail + '">\
                <i class="icon-bookmark"></i>\
                <i class="icon-bookmark-filled"></i>\
              </div>\
            </div>'
          );
          $(el).addClass('collectible-content');
        } else if(elementType==='inline') {
          $(el).html(
            '<a class="btn-collect' + (collectedIn.length?' selected':'') + ($(el).attr('data-classes')?' '+$(el).attr('data-classes'):'')+'" data-id="' + id + '" data-type="' + type + '" data-title="' + title + '" data-thumbnail="' + thumbnail + '">\
              <i class="icon-bookmark"></i>\
              <i class="icon-bookmark-filled"></i>\
              <span class="add-to-collection">Add to collection</span>\
              <span class="added-to-collection">Added to collection</span>\
            </a>'
          );
        }
      }
    }
    var renderCollectible = function(item, classes){
      classes = classes || "";
      return '<div class="content-result in-collection-tray'+(classes?' '+classes:'')+'" data-id="'+item.id+'" data-type="'+item.type+'">\
                <i class="icon-trash-light btn-round" data-id="'+item.id+'" data-type="'+item.type+'"></i>\
                <div class="content-result-link">\
                  <div class="front-section">\
                    <div class="image">\
                      <img src="'+item.thumbnail+'">\
                    </div>\
                    <div class="content-title">\
                      <div class="font-primary-bold title"><span>'+item.title+'</span></div>\
                      <div class="content-type"><div class="content-type-name">'+item.type+'</div></div>\
                    </div>\
                  </div>\
                </div>\
              </div>';
    };
    var clickClose = function() {
      if(collectionId==='pending'){
        if($('#collections').hasClass('page-new-collection')){
          toPage('choose-collection');
        } else {
          $('#collections').removeClass('active');
          if(!collectibleContent[pendingItem.type+'|'+pendingItem.id] || (collectibleContent[pendingItem.type+'|'+pendingItem.id] && Object.keys(collectibleContent[pendingItem.type+'|'+pendingItem.id].collectedIn).length===0) ) {
            $('.btn-collect.selected[data-id=' + pendingItem.id + '][data-type=' + pendingItem.type + ']').removeClass('selected');
          }
          pendingItem = null;
        }
      } else {
        toPage('collection');
      }
    }
    var clickCollect = function() {
      var type = $(this).attr('data-type');
      var id = $(this).attr('data-id');
      var title = $(this).attr('data-title');
      var thumbnail = $(this).attr('data-thumbnail');

      // Collections are a premium-only feature
      if(window.Edu && window.Edu.accountType === 'Anonymous') {
        $('#collections-featurewall').modal('show', {type: type, id: id});
        return;
      }

      var key = type+'|'+id;
      var item = {id: id, type: type, title: title, thumbnail: thumbnail};

      if (collectionId==='pending') {
        pendingItem = item;
        $(this).addClass('selected');
        toPage('choose-collection');
      } else {
        if(!(key in collections[collectionId].content)) {
          var resp = addToCollection(item);
          if(resp) {
            $(this).addClass('selected');
          }
        } else {
          removeFromCollection(item);
        }
      }
      $('#collections').addClass('active');
    }

    var addToCollection = function(item) {
      if(Object.keys(collections[collectionId].content).length >= 50){
        $('#collections .error').removeClass('inactive').html("This collection is full");
        clearTimeout(timeout);
        timeout = setTimeout(function(){
          $('#collections .error').addClass('inactive').html("");
        }, 5000);
        return false;
      }
      var key = item.type + '|' + item.id;
      collections[collectionId].content[key] = item;
      var count = Object.keys(collections[collectionId].content).length;
      $('#collections .collection .count').addClass('animate').html(count);
      setTimeout(function(){
        $('#collections .collection .count').removeClass('animate');
      }, 250);
      $('#collections .collection .count-label').html((count>1||count==0)?'items':'item');
      $('#collections .collection .right').prepend(renderCollectible(item, 'added'));
      $('#collections .content-result').on('click', '.icon-trash-light', function(){
        removeFromCollection({id: $(this).attr('data-id'), type: $(this).attr('data-type')});
      });
      if(count<=1) {
        $('#collections .collection').removeClass('minimized');
      }
      collectibleContent[item.type+'|'+item.id].collectedIn.push(collectionId);
      $.ajax({url: '/api/collections/addToMemberCollection', method: 'post', data: {
        collectionId: collectionId,
        content: [{id: item.id, type: item.type}]
      }}).done(function(data){
        if(window.Edu && window.Edu.trackEvent) {
          window.Edu.trackEvent('collections', {
            action: "added to collection",
            itemType: item.type,
            itemId: item.id,
            collectionId: collectionId
          }, {
            eventCategory: "Collections",
            eventAction: "Added to collection"
          });
        }
        // console.log(data);
      });
      return true;
    }

    var removeFromCollection = function(item) {
      var key = item.type + '|' + item.id;
      delete collections[collectionId].content[key];
      var count = Object.keys(collections[collectionId].content).length;
      $('#collections .collection .count').addClass('animate').html(count);
      setTimeout(function(){
        $('#collections .collection .count').removeClass('animate');
      }, 250);
      $('#collections .collection .count-label').html((count>1||count==0)?'items':'item');
      var $itemEl = $('#collections .collection .right .content-result[data-id='+item.id+'][data-type='+item.type+']');
      $itemEl.removeClass('added').addClass('removed');
      setTimeout(function() {
        $itemEl.remove();
      }, 250);
      if( (item.type+'|'+item.id) in collectibleContent && collectibleContent[item.type+'|'+item.id].collectedIn) {
        var collectedInIndex = collectibleContent[item.type + '|' + item.id].collectedIn.indexOf(collectionId);
        if (collectedInIndex !== -1) {
          collectibleContent[item.type + '|' + item.id].collectedIn.splice(collectedInIndex, 1);
          if (!(collectibleContent[item.type + '|' + item.id].collectedIn.length)) {
            $('.btn-collect[data-id=' + item.id + '][data-type=' + item.type + ']').removeClass('selected');
          }
        }
      }
      $.ajax({url: '/api/collections/removeFromMemberCollection', method: 'post', data: {
        collectionId: collectionId,
        content: [{id: item.id, type: item.type}]
      }}).done(function(data){
        if(window.Edu && window.Edu.trackEvent) {
          window.Edu.trackEvent('collections', {
            action: "removed from collection",
            itemType: item.type,
            itemId: item.id,
            collectionId: collectionId
          }, {
            eventCategory: "Collections",
            eventAction: "Removed from collection"
          });
        }
        // console.log(data);
      });
    }

    var submitNewCollection = function() {
      var collectionTitle = $('#collections .new-collection input[name=title]').val().trim();
      $('#collections .new-collection input[name=title]').val(collectionTitle);
      if(collectionTitle!=="") {
        $('#collections .new-collection .btn-save').addClass('disabled');
        var postData = {title: collectionTitle};
        $.ajax({url: '/api/collections/createCollection', method: 'post', data: postData})
        .done(function(data){
          if(data.status) {
            $('#collections .new-collection .btn-save').removeClass('disabled');
            $('#collections .new-collection input[name=title]').val("");
            collectionId = data.collection.id;
            if (data.collection && data.collection.id) {
              collections[data.collection.id] = data.collection;
              $('#collections .choose-collection .list').append(
                '<div class="item" data-id="' + data.collection.id + '">\
                <div class="icon" style="background-image: url(' + window.Edu.prefixCDN(data.collection.thumbnail) + ')"></div>\
                <div class="label">' + data.collection.title + '</div>\
              </div>'
              );
              var count = Object.keys(collections[collectionId].content).length;
              $('#collections .collection .count').html(count);
              $('#collections .collection .count-label').html((count > 1 || count == 0) ? 'items' : 'item');
              $('#collections .collection .right').html("");
            }
            if(window.Edu && window.Edu.trackEvent) {
              window.Edu.trackEvent('collections', {
                action: "created collection"
              }, {
                eventCategory: "Collections",
                eventAction: "Created new collection"
              });
            }
            toPage('collection', ($(window).width()>600)?true:false);
          } else {
            $('#collections .new-collection .btn-save').removeClass('disabled');
            console.log('failed create collection', data);
            $('#collections .error').removeClass('inactive').html(data.error.message || "Cannot create collection");
            clearTimeout(timeout);
            timeout = setTimeout(function(){
              $('#collections .error').addClass('inactive').html("");
            }, 5000);
          }
        }).fail(function(){
          $('#collections .new-collection .btn-save').removeClass('disabled');
          console.log('failed create collection', data);
          $('#collections .error').removeClass('inactive').html("Cannot create collection");
          clearTimeout(timeout);
          timeout = setTimeout(function(){
            $('#collections .error').addClass('inactive').html("");
          }, 5000);
        });
      }
    }

    var setCollection = function(c) {
      collectionId = c;
    }

    var toPage = function(page, startMaximized) {
      startMaximized = startMaximized || false;
      $('#collections').removeClass('page-collection page-choose-collection page-new-collection').addClass('page-'+page);
      if(page==='collection'){
        $('#collections').addClass('active');
        if(startMaximized) {
          $('#collections .collection').removeClass('minimized');
        }
        $('#collections .collection .title a').html(collections[collectionId].title);
        $('#collections .collection .full .title a').attr('href', '/my/collections/'+collections[collectionId].url);
        var count = Object.keys(collections[collectionId].content).length;
        $('#collections .collection .count').html(count);
        $('#collections .collection .count-label').html((count>1||count==0)?'items':'item');
        $('#collections .collection .right').html('');
        if(collectionId in collections){
          for(var key in collections[collectionId].content){
            var item = collections[collectionId].content[key];
            $('#collections .collection .right').append(renderCollectible(item));
          }
          $('#collections .content-result').on('click', '.icon-trash-light', function(){
            removeFromCollection({id: $(this).attr('data-id'), type: $(this).attr('data-type')});
          });
        }
        if(pendingItem && pendingItem.id && pendingItem.type){
          addToCollection(pendingItem);
          pendingItem = null;
        }
      }
    };

    var fetchCollections = function() {
      // only fetch if we haven't fetched yet
      if(fetchedCollections) return;

      // only fetch if there is collectible content on the page
      if(Object.keys(collectibleContent).length) {
        fetchedCollections = true;
        $.ajax({url: '/api/collections/memberCollections'})
          .done(function (data) {
            if (data.collections && data.contentModels) {
              collections = data.collections;
              for (var cid in collections) {
                for (var contentId in collections[cid].content) {
                  collections[cid].content[contentId] = $.extend(true, {}, collections[cid].content[contentId], data.contentModels[contentId]);
                }
                $('#collections .choose-collection .list').append(
                  '<div class="item" data-id="' + cid + '">\
                    <div class="icon'+(!(collections[cid].thumbnail) ? " empty" : "")+'" style="background-image: url(' + window.Edu.prefixCDN(collections[cid].thumbnail) + ')">\
                    '+(!(collections[cid].thumbnail) ? "Empty" : "")+'\
                    </div>\
                    <div class="label"><span>' + collections[cid].title + '</span></div>\
                  </div>'
                );
              }
              populate();
            }
            var now = data.now;
            var dateUpdated = data.dateUpdated || now;
            var recency = ( (new Date(now)).valueOf() - (new Date(dateUpdated)).valueOf() )/1000;
            // console.log(recency, now, dateUpdated);
            if (recency<(3*3600) && data.currentCollection) {       // exists and is within 3 hour session
              collectionId = data.currentCollection;
              toPage('collection');
            } else {
              collectionId = "pending";
              toPage('choose-collection');
            }
            $('.collectible-content-item.inline').removeClass('disabled');
          })
          .fail(function () {
            fetchedCollections = false;
            console.log('failed collection fetch');
          });
      }
    };

    var init = function() {
      // if anonymous, skip the fetchCollections call:
      if(window.Edu && window.Edu.accountType==="Anonymous") {
        fetchedCollections = true;
      }

      populate();
      $(window).on('renderContentCards', populate);
      if(!Object.keys(collectibleContent).length) {
        $('#collections').addClass('hidden');
      } else {
        $('#collections').removeClass('hidden');
      }
      if($(window).width()<=600) {
        $('#collections .collection').addClass('minimized');
      }
      $(document).on('click', '.btn-collect', clickCollect);
      $('#collections .choose-collection .icon-cancel-light').click(clickClose);
      $('#collections .new-collection .icon-cancel-light').click(clickClose);
      $('#collections .new-collection .btn-cancel').click(clickClose);
      $('#collections .overlay-back').click(clickClose);
      $('#collections .collection .btn-minimize').click(function(){
        $('#collections .collection').addClass('minimized');
      });
      $('#collections .collection .ribbon').click(function(){
        $('#collections .collection').removeClass('minimized');
      });
      $('#collections .collection .btn-change-collection').click(function(){
        $('#collections .choose-collection .title').html('Choose collection');
        toPage('choose-collection');
      });
      $('#collections .choose-collection .list').on('click', '.item', function(){
        collectionId = $(this).attr('data-id');
        toPage('collection', ($(window).width()>600)?true:false);
      });
      $('#collections .choose-collection').on('click', '.item.new', function(){
        toPage('new-collection');
      });
      $('#collections .new-collection .btn-save').click(submitNewCollection);

      // Fetch the user's collections before showing anything
      fetchCollections();
    };

    return {
      init: init,
      populate: populate,
      populateItem: populateItem,
      clickCollect: clickCollect,
      setCollection: setCollection
    }
  })();

  $(document).ready(function() {
    window.Edu.Collectible.init();
  });



  $(document).on('click', '.messagestack .close-message', function () {
    $(this).parents('.messagestack-message').fadeOut('slow', function() {});
  });

  $(document).ready(function () {
    function FilterScroll () {
      this.scrollContainers = $('.filter-scroll-container');
      this.scrollNav = $('.filter-scroll-nav');
      this.updateSelected = function () {
        for(var i = 0; i < this.scrollContainers.length; i++) {
          var viewportYPosition = $(window).scrollTop() + parseInt($(this.scrollContainers[i]).attr('data-top-margin'));

          if (viewportYPosition > $(this.scrollContainers[i]).offset().top) {
            this.scrollNav.find('.filter-scroll-selected').removeClass('filter-scroll-selected');
            $('.filter-scroll-index-'+i).addClass('filter-scroll-selected');
          }
        }
      };
    }

    if ('.filter-scroll-container'.length > 0) {
      var filterScroll = new FilterScroll();

      $(window).scroll(function() {
        filterScroll.updateSelected();
      });
    }
  });
  /**
   * @preserve FastClick: polyfill to remove click delays on browsers with touch UIs.
   *
   * @codingstandard ftlabs-jsv2
   * @copyright The Financial Times Limited [All Rights Reserved]
   * @license MIT License (see LICENSE.txt)
   */
  !function(){"use strict";function t(e,o){function i(t,e){return function(){return t.apply(e,arguments)}}var r;if(o=o||{},this.trackingClick=!1,this.trackingClickStart=0,this.targetElement=null,this.touchStartX=0,this.touchStartY=0,this.lastTouchIdentifier=0,this.touchBoundary=o.touchBoundary||10,this.layer=e,this.tapDelay=o.tapDelay||200,this.tapTimeout=o.tapTimeout||700,!t.notNeeded(e)){for(var a=["onMouse","onClick","onTouchStart","onTouchMove","onTouchEnd","onTouchCancel"],c=this,s=0,u=a.length;u>s;s++)c[a[s]]=i(c[a[s]],c);n&&(e.addEventListener("mouseover",this.onMouse,!0),e.addEventListener("mousedown",this.onMouse,!0),e.addEventListener("mouseup",this.onMouse,!0)),e.addEventListener("click",this.onClick,!0),e.addEventListener("touchstart",this.onTouchStart,!1),e.addEventListener("touchmove",this.onTouchMove,!1),e.addEventListener("touchend",this.onTouchEnd,!1),e.addEventListener("touchcancel",this.onTouchCancel,!1),Event.prototype.stopImmediatePropagation||(e.removeEventListener=function(t,n,o){var i=Node.prototype.removeEventListener;"click"===t?i.call(e,t,n.hijacked||n,o):i.call(e,t,n,o)},e.addEventListener=function(t,n,o){var i=Node.prototype.addEventListener;"click"===t?i.call(e,t,n.hijacked||(n.hijacked=function(t){t.propagationStopped||n(t)}),o):i.call(e,t,n,o)}),"function"==typeof e.onclick&&(r=e.onclick,e.addEventListener("click",function(t){r(t)},!1),e.onclick=null)}}var e=navigator.userAgent.indexOf("Windows Phone")>=0,n=navigator.userAgent.indexOf("Android")>0&&!e,o=/iP(ad|hone|od)/.test(navigator.userAgent)&&!e,i=o&&/OS 4_\d(_\d)?/.test(navigator.userAgent),r=o&&/OS [6-7]_\d/.test(navigator.userAgent),a=navigator.userAgent.indexOf("BB10")>0;t.prototype.needsClick=function(t){switch(t.nodeName.toLowerCase()){case"button":case"select":case"textarea":if(t.disabled)return!0;break;case"input":if(o&&"file"===t.type||t.disabled)return!0;break;case"label":case"iframe":case"video":return!0}return/\bneedsclick\b/.test(t.className)},t.prototype.needsFocus=function(t){switch(t.nodeName.toLowerCase()){case"textarea":return!0;case"select":return!n;case"input":switch(t.type){case"button":case"checkbox":case"file":case"image":case"radio":case"submit":return!1}return!t.disabled&&!t.readOnly;default:return/\bneedsfocus\b/.test(t.className)}},t.prototype.sendClick=function(t,e){var n,o;document.activeElement&&document.activeElement!==t&&document.activeElement.blur(),o=e.changedTouches[0],n=document.createEvent("MouseEvents"),n.initMouseEvent(this.determineEventType(t),!0,!0,window,1,o.screenX,o.screenY,o.clientX,o.clientY,!1,!1,!1,!1,0,null),n.forwardedTouchEvent=!0,t.dispatchEvent(n)},t.prototype.determineEventType=function(t){return n&&"select"===t.tagName.toLowerCase()?"mousedown":"click"},t.prototype.focus=function(t){var e;o&&t.setSelectionRange&&0!==t.type.indexOf("date")&&"time"!==t.type&&"month"!==t.type?(e=t.value.length,t.setSelectionRange(e,e)):t.focus()},t.prototype.updateScrollParent=function(t){var e,n;if(e=t.fastClickScrollParent,!e||!e.contains(t)){n=t;do{if(n.scrollHeight>n.offsetHeight){e=n,t.fastClickScrollParent=n;break}n=n.parentElement}while(n)}e&&(e.fastClickLastScrollTop=e.scrollTop)},t.prototype.getTargetElementFromEventTarget=function(t){return t.nodeType===Node.TEXT_NODE?t.parentNode:t},t.prototype.onTouchStart=function(t){var e,n,r;if(t.targetTouches.length>1)return!0;if(e=this.getTargetElementFromEventTarget(t.target),n=t.targetTouches[0],o){if(r=window.getSelection(),r.rangeCount&&!r.isCollapsed)return!0;if(!i){if(n.identifier&&n.identifier===this.lastTouchIdentifier)return t.preventDefault(),!1;this.lastTouchIdentifier=n.identifier,this.updateScrollParent(e)}}return this.trackingClick=!0,this.trackingClickStart=t.timeStamp,this.targetElement=e,this.touchStartX=n.pageX,this.touchStartY=n.pageY,t.timeStamp-this.lastClickTime<this.tapDelay&&t.preventDefault(),!0},t.prototype.touchHasMoved=function(t){var e=t.changedTouches[0],n=this.touchBoundary;return Math.abs(e.pageX-this.touchStartX)>n||Math.abs(e.pageY-this.touchStartY)>n?!0:!1},t.prototype.onTouchMove=function(t){return this.trackingClick?((this.targetElement!==this.getTargetElementFromEventTarget(t.target)||this.touchHasMoved(t))&&(this.trackingClick=!1,this.targetElement=null),!0):!0},t.prototype.findControl=function(t){return void 0!==t.control?t.control:t.htmlFor?document.getElementById(t.htmlFor):t.querySelector("button, input:not([type=hidden]), keygen, meter, output, progress, select, textarea")},t.prototype.onTouchEnd=function(t){var e,a,c,s,u,l=this.targetElement;if(!this.trackingClick)return!0;if(t.timeStamp-this.lastClickTime<this.tapDelay)return this.cancelNextClick=!0,!0;if(t.timeStamp-this.trackingClickStart>this.tapTimeout)return!0;if(this.cancelNextClick=!1,this.lastClickTime=t.timeStamp,a=this.trackingClickStart,this.trackingClick=!1,this.trackingClickStart=0,r&&(u=t.changedTouches[0],l=document.elementFromPoint(u.pageX-window.pageXOffset,u.pageY-window.pageYOffset)||l,l.fastClickScrollParent=this.targetElement.fastClickScrollParent),c=l.tagName.toLowerCase(),"label"===c){if(e=this.findControl(l)){if(this.focus(l),n)return!1;l=e}}else if(this.needsFocus(l))return t.timeStamp-a>100||o&&window.top!==window&&"input"===c?(this.targetElement=null,!1):(this.focus(l),this.sendClick(l,t),o&&"select"===c||(this.targetElement=null,t.preventDefault()),!1);return o&&!i&&(s=l.fastClickScrollParent,s&&s.fastClickLastScrollTop!==s.scrollTop)?!0:(this.needsClick(l)||(t.preventDefault(),this.sendClick(l,t)),!1)},t.prototype.onTouchCancel=function(){this.trackingClick=!1,this.targetElement=null},t.prototype.onMouse=function(t){return this.targetElement?t.forwardedTouchEvent?!0:t.cancelable&&(!this.needsClick(this.targetElement)||this.cancelNextClick)?(t.stopImmediatePropagation?t.stopImmediatePropagation():t.propagationStopped=!0,t.stopPropagation(),t.preventDefault(),!1):!0:!0},t.prototype.onClick=function(t){var e;return this.trackingClick?(this.targetElement=null,this.trackingClick=!1,!0):"submit"===t.target.type&&0===t.detail?!0:(e=this.onMouse(t),e||(this.targetElement=null),e)},t.prototype.destroy=function(){var t=this.layer;n&&(t.removeEventListener("mouseover",this.onMouse,!0),t.removeEventListener("mousedown",this.onMouse,!0),t.removeEventListener("mouseup",this.onMouse,!0)),t.removeEventListener("click",this.onClick,!0),t.removeEventListener("touchstart",this.onTouchStart,!1),t.removeEventListener("touchmove",this.onTouchMove,!1),t.removeEventListener("touchend",this.onTouchEnd,!1),t.removeEventListener("touchcancel",this.onTouchCancel,!1)},t.notNeeded=function(t){var e,o,i,r;if("undefined"==typeof window.ontouchstart)return!0;if(o=+(/Chrome\/([0-9]+)/.exec(navigator.userAgent)||[,0])[1]){if(!n)return!0;if(e=document.querySelector("meta[name=viewport]")){if(-1!==e.content.indexOf("user-scalable=no"))return!0;if(o>31&&document.documentElement.scrollWidth<=window.outerWidth)return!0}}if(a&&(i=navigator.userAgent.match(/Version\/([0-9]*)\.([0-9]*)/),i[1]>=10&&i[2]>=3&&(e=document.querySelector("meta[name=viewport]")))){if(-1!==e.content.indexOf("user-scalable=no"))return!0;if(document.documentElement.scrollWidth<=window.outerWidth)return!0}return"none"===t.style.msTouchAction||"manipulation"===t.style.touchAction?!0:(r=+(/Firefox\/([0-9]+)/.exec(navigator.userAgent)||[,0])[1],r>=27&&(e=document.querySelector("meta[name=viewport]"),e&&(-1!==e.content.indexOf("user-scalable=no")||document.documentElement.scrollWidth<=window.outerWidth))?!0:"none"===t.style.touchAction||"manipulation"===t.style.touchAction?!0:!1)},t.attach=function(e,n){return new t(e,n)},"function"==typeof define&&"object"==typeof define.amd&&define.amd?define(function(){return t}):"undefined"!=typeof module&&module.exports?(module.exports=t.attach,module.exports.FastClick=t):window.FastClick=t}();

  // For generating CJ event id and cookie
  (function() {
    var _t = 'cjevent'.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var results = new RegExp("[\\?&]" + _t + "=([^&#]*)").exec(location.search);
    var cjevent = (results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, " ")));

    if (cjevent !== '') {
      var now = new Date();
      var time = now.getTime();
      var expTime = time + 1000*31536000;
      now.setTime(expTime);
      document.cookie = "cjevent=" + cjevent + "; expires=" + now.toUTCString() + "; path=/";
    }
  })();

})(window.jQuery||window.Zepto);
